
// import dayjs from 'dayjs' // 时间转换
import Fingerprint2 from 'fingerprintjs2'
import riskModule from '~/components/common/riskModuleFxeye.vue'
import wikiHead from '~/components/common/wikiHead.vue'
import wikiFooter from '~/components/common/wikiFooter.vue'
// import headTips from '~/components/home/headTips.vue'
import footerTips from '~/components/home/footerTips.vue'
import { debounce, setImg } from '~/utils/utils'
export default {
  name: 'WikiDefault',
  components: {
    'risk-module': riskModule,
    'wiki-head': wikiHead,
    'wiki-footer': wikiFooter,
    // 'head-tips': headTips,
    'footer-tips': footerTips
  },
  data() {
    return {
      adData: {}, // 底部广告
      topadshow: false,
      topaddata: {}, // 顶部 广告
      webtype: this.$route?.query?.source,
      headh: this.$route?.query?.headh || 0,
      sss: '',
      headshow: true // 顶部提示是否显示
    }
  },
  head() {
    // 不显示hreflang页面-资讯详情页、教育文章详情页、百科详情页、交易商介绍详情页
    // console.log(this.$route.name, 8885)
    const show = ['lang-learnlist-graduation-id', 'lang-learnlist-undergraduate-id', 'lang-learnlist-highschool-id', 'lang-learnlist-summer-camp-id', 'lang-learnlist-middleschool-id', 'lang-learnlist-elementary.html', 'lang-learnlist-pre-school-id', 'lang-learnlist-id', 'lang-authority-id', 'lang-evaluation-id', 'lang-wikilist-id', 'lang-brokernews-id', 'lang-industry-id', 'lang-original-id', 'lang-news-id', 'lang-word-id', 'learn', 'wikishow', 'lang-newsdetail-id', 'lang-learn-id', 'lang-wikishow-id', 'lang-intro-id', 'lang-exposure-add.html']
    const canonicalshow = ['lang-learnlist-graduation-id', 'lang-learnlist-undergraduate-id', 'lang-learnlist-highschool-id', 'lang-learnlist-summer-camp-id', 'lang-learnlist-middleschool-id', 'lang-learnlist-elementary.html', 'lang-learnlist-pre-school-id', 'lang-learnlist-id', 'lang-authority-id', 'lang-evaluation-id', 'lang-wikilist-id', 'lang-brokernews-id', 'lang-industry-id', 'lang-original-id', 'lang-news-id', 'lang-exposure-add.html']
    let ate = []
    let canonicalarr = []
    if (!show.includes(this.$route.name)) {
      ate = [...this.alternate()]
    }
    if (!canonicalshow.includes(this.$route.name)) canonicalarr = [...this.canonical()]

    let googleurl = ''
    if (this.$store.state.myCountry != 'cn' && this.$store.state.isWiki == '1' && !this.$store.state.cookieHost.includes('fxeyetips.com') && !this.$store.state.cookieHost.includes('fxeyevip.com')) {
      googleurl = 'https://www.googletagmanager.com/gtag/js?id=UA-172151915-1'
    } else if (this.$store.state.myCountry != 'cn' && this.$store.state.isWiki == '3' && !this.$store.state.cookieHost.includes('fxeyetips.com') && !this.$store.state.cookieHost.includes('fxeyevip.com')) {
      googleurl = 'https://www.googletagmanager.com/gtag/js?id=UA-172151915-10'
    } else if (this.$store.state.myCountry != 'cn' && (this.$store.state.isWiki == '2' || this.$store.state.isWiki == '4') && !this.$store.state.cookieHost.includes('fxeyetips.com') && !this.$store.state.cookieHost.includes('fxeyevip.com')) {
      googleurl = 'https://www.googletagmanager.com/gtag/js?id=UA-172113747-5'
    }
    const icon = this.$store.state.isWiki == '1' || this.$store.state.isWiki == '3' ? 'https://resources1.interface003.com/web20/img/favicon-wikifx.ico' : 'https://resources1.interface003.com/web20/img/favicon-fxeye.ico'

    // const taboola = {}
    // if ((this.$store.state.isWiki == '1' || this.$store.state.isWiki == '3') && (this.$store.state.LanguageCode == 'en')) {
    //   Object.assign(taboola, {
    //     type: 'text/javascript',
    //     innerHTML: 'window._tfa = window._tfa || [];window._tfa.push({notify: `event`, name: `page_view`, id: 1480928});!function (t, f, a, x) {if (!document.getElementById(x)) {t.async = 1;t.src = a;t.id=x;f.parentNode.insertBefore(t, f);}}(document.createElement(`script`),document.getElementsByTagName(`script`)[0],`//cdn.taboola.com/libtrc/unip/1480928/tfa.js`,`tb_tfa_script`);'
    //   })
    // }
    // www.fxeyema.com增加统计代码$store.state.cookieHost.includes('fxeyema.com')
    const fxeyemaurl = {}
    const fxeyemajs = {}
    const fxeyemapex = {}
    const rptxt = {
      src: 'https://resources1.interface003.com/web20/js/rptxt.js',
      body: false,
      async: true
    }
    const eeeoeee = {}
    let allga = {} // 新的ga统计代码，不限域名，所有的都有
    if (this.$store.state.myCountry != 'cn') {
      allga = {
        src: 'https://www.googletagmanager.com/gtag/js?id=G-EH7WFXEEHY',
        body: false,
        async: true
      } // 新的ga统计代码，不限域名，所有的都有
    }
    if (this.$store.state.myCountry != 'cn') {
      Object.assign(fxeyemaurl, {
        src: 'https://www.googletagmanager.com/gtag/js?id=AW-16664282015',
        body: false,
        async: true
      })
      Object.assign(fxeyemajs, {
        type: 'text/javascript',
        innerHTML: 'window.dataLayer = window.dataLayer || [];function gtag(){dataLayer.push(arguments);}gtag(`js`, new Date());gtag(`config`, `AW-16664282015`);'
      })
    }

    if (this.$store.state.cookieHost.includes('fxeyetips.com') || this.$store.state.cookieHost.includes('fxeyevip.com') || this.$store.state.cookieHost.includes('fxeyema.com')) {
      Object.assign(fxeyemapex, {
        src: '/js/tiktok.js',
        body: false,
        async: true
      })
    }

    const fxeyetipsurl = {}
    if ((this.$store.state.myCountry != 'cn' && this.$store.state.cookieHost.includes('fxeyetips.com')) || this.$store.state.cookieHost.includes('fxeyevip.com')) {
      Object.assign(fxeyetipsurl, {
        src: 'https://www.googletagmanager.com/gtag/js?id=G-8WQ1KZN2WL',
        body: false,
        async: true
      })
    }

    const chost = this.$store.state.cookieHost
    if (chost.includes('wikifx.com')) {
      Object.assign(eeeoeee, {
        src: '/contentgj/eeeoeee.js',
        body: false,
        async: true
      })
    } else if (chost.includes('wikifxact.com')) {
      Object.assign(eeeoeee, {
        src: '/contentgj/eeeoeee2.js',
        body: false,
        async: true
      })
    } else if (chost.includes('fxeyetips.com')) {
      Object.assign(eeeoeee, {
        src: '/contentgj/eeeoeee3.js',
        body: false,
        async: true
      })
    } else if (chost.includes('wikifx.vip')) {
      Object.assign(eeeoeee, {
        src: '/contentgj/eeeoeee4.js',
        body: false,
        async: true
      })
    } else if (chost.includes('fxeye2017.com')) {
      Object.assign(eeeoeee, {
        src: '/contentgj/eeeoeee5.js',
        body: false,
        async: true
      })
    } else if (chost.includes('wikifx2.com')) {
      Object.assign(eeeoeee, {
        src: '/contentgj/eeeoeee6.js',
        body: false,
        async: true
      })
    } else if (chost.includes('shareowen.com')) {
      Object.assign(eeeoeee, {
        src: '/contentgj/eeeoeee7.js',
        body: false,
        async: true
      })
    } else if (chost.includes('mchgi.com')) {
      Object.assign(eeeoeee, {
        src: '/contentgj/eeeoeee8.js',
        body: false,
        async: true
      })
    } else if (chost.includes('wikifx25.com')) {
      Object.assign(eeeoeee, {
        src: '/contentgj/eeeoeee9.js',
        body: false,
        async: true
      })
    } else if (chost.includes('fxeye25.com')) {
      Object.assign(eeeoeee, {
        src: '/contentgj/eeeoeee10.js',
        body: false,
        async: true
      })
    } else if (chost.includes('fxeyema.com')) {
      Object.assign(eeeoeee, {
        src: '/contentgj/eeeoeee11.js',
        body: false,
        async: true
      })
    } else if (chost.includes('fxeyecn.com')) {
      Object.assign(eeeoeee, {
        src: '/contentgj/eeeoeee12.js',
        body: false,
        async: true
      })
    } else if (chost.includes('wikifxvn.com')) {
      Object.assign(eeeoeee, {
        src: '/contentgj/eeeoeee13.js',
        body: false,
        async: true
      })
    } else if (chost.includes('wikifxvi.com')) {
      Object.assign(eeeoeee, {
        src: '/contentgj/eeeoeee14.js',
        body: false,
        async: true
      })
    } else if (chost.includes('wikifxen.com')) {
      Object.assign(eeeoeee, {
        src: '/contentgj/eeeoeee15.js',
        body: false,
        async: true
      })
    } else if (chost.includes('wikifxzh.com')) {
      Object.assign(eeeoeee, {
        src: '/contentgj/eeeoeee16.js',
        body: false,
        async: true
      })
    } else if (chost.includes('wikifxka.com')) {
      Object.assign(eeeoeee, {
        src: '/contentgj/eeeoeee17.js',
        body: false,
        async: true
      })
    } else if (chost.includes('wikifxcn.com')) {
      Object.assign(eeeoeee, {
        src: '/contentgj/eeeoeee18.js',
        body: false,
        async: true
      })
    } else if (chost.includes('fxeye110.com')) {
      Object.assign(eeeoeee, {
        src: '/contentgj/eeeoeee19.js',
        body: false,
        async: true
      })
    } else if (chost.includes('fxeye123.com')) {
      Object.assign(eeeoeee, {
        src: '/contentgj/eeeoeee20.js',
        body: false,
        async: true
      })
    } else if (chost.includes('fxeye777.com')) {
      Object.assign(eeeoeee, {
        src: '/contentgj/eeeoeee21.js',
        body: false,
        async: true
      })
    } else if (chost.includes('fxeye688.com')) {
      Object.assign(eeeoeee, {
        src: '/contentgj/eeeoeee22.js',
        body: false,
        async: true
      })
    } else if (chost.includes('fxeye.com')) {
      Object.assign(eeeoeee, {
        src: '/contentgj/eeeoeee23.js',
        body: false,
        async: true
      })
    } else if (chost.includes('fxeyevn.com')) {
      Object.assign(eeeoeee, {
        src: '/contentgj/eeeoeee24.js',
        body: false,
        async: true
      })
    } else if (chost.includes('fxeyevi.com')) {
      Object.assign(eeeoeee, {
        src: '/contentgj/eeeoeee25.js',
        body: false,
        async: true
      })
    } else if (chost.includes('fxeye555.com')) {
      Object.assign(eeeoeee, {
        src: '/contentgj/eeeoeee26.js',
        body: false,
        async: true
      })
    } else if (chost.includes('fxeye2021.com')) {
      Object.assign(eeeoeee, {
        src: '/contentgj/eeeoeee27.js',
        body: false,
        async: true
      })
    } else if (chost.includes('fxeyefx.com')) {
      Object.assign(eeeoeee, {
        src: '/contentgj/eeeoeee28.js',
        body: false,
        async: true
      })
    } else if (chost.includes('fxeyevps.com')) {
      Object.assign(eeeoeee, {
        src: '/contentgj/eeeoeee29.js',
        body: false,
        async: true
      })
    } else if (chost.includes('wikifx.hk')) {
      Object.assign(eeeoeee, {
        src: '/contentgj/eeeoeee30.js',
        body: false,
        async: true
      })
    } else if (chost.includes('wikifxtips.com')) {
      Object.assign(eeeoeee, {
        src: '/contentgj/eeeoeee31.js',
        body: false,
        async: true
      })
    } else if (chost.includes('fxeyevip.com')) {
      Object.assign(eeeoeee, {
        src: '/contentgj/eeeoeee33.js',
        body: false,
        async: true
      })
    } else if (chost.includes('fxeyeka.com')) {
      Object.assign(eeeoeee, {
        src: '/contentgj/eeeoeee34.js',
        body: false,
        async: true
      })
    }
    return {
      htmlAttrs: {
        lang: this.$route.params.lang == 'fil' ? 'tl' : this.$route.params.lang,
        dir: this.$route.params.lang == 'ar' ? 'rtl' : 'ltr'
      },
      // title: '\u200F' + 'title',
      link: [...ate, ...canonicalarr, { rel: 'icon', type: 'image/x-icon', href: icon }],
      script: [
        eeeoeee,
        rptxt,
        fxeyemaurl,
        allga,
        {
          charset: 'utf-8',
          src: googleurl,
          body: false,
          async: true
        },
        fxeyemajs,
        fxeyemapex,
        fxeyetipsurl
      ]
      // }, taboola]
    }
  },
  mounted() {
    console.log(this.$route.name, 1123)
    this.headshow = this.$Cookie.get('head_tips')
    this.$store.commit('setisie', window.ActiveXObject || 'ActiveXObject' in window)
    if (!this.$Cookie.get('wiki-bfp')) this.setBfp() // 浏览器指纹码
    // this.Loginoperation() // 登录相关操作
    const _this = this
    this.setIsMobile()
    // this.getheadtipsheightfn()
    window.addEventListener('resize', function () {
      _this.setIsMobile()
      // _this.getheadtipsheightfn()
      if (!_this.$store.state.adshow) return
      _this.adisShow()
    })
    this.localroutefn()
    this.$nextTick(() => {
      // setImg()
      this.scrollImg(true)
    })
    this.adisShow()
  },
  methods: {
    closehead() {
      // 关闭顶部提示
      this.headshow = true
    },
    getheadtipsheightfn() {
      // 获取tips高度
      // if (!this.$route.name.includes('lang')) return
      // this.$nextTick(() => {
      //   const eleh = document.getElementById('head-tips')?.clientHeight || 0
      //   this.$store.commit('settipsheight', eleh)
      // })
    },
    Loginoperation() {
      // 实现登录操作
      // console.log(123);
      const that = this
      window.addEventListener(
        'message',
        function (e) {
          // console.log(e.data, 22234)
          const ret = e.data
          if (ret) {
            if (ret.op_type == 'reload') {
              // console.log('reload', 33333)
              window.location.reload()
            } else if (ret.op_type == 'close') {
              // console.log('close', 5555)
              that.loginShow = false
            } else if (ret.op_type == 'opennew' && ret.url) {
              if (ret.url.includes('##')) {
                const urlCur = window.location.href
                window.location.href = ret.url.replace('##', urlCur)
              } else {
                window.location.href = ret.url
              }
            }
          }
        },
        { passive: true }
      )
    },
    setBfp() {
      // 浏览器指纹码
      Fingerprint2.get((components) => {
        // 浏览器指纹码
        const values = components.map(function (component, index) {
          if (index == 0) {
            // 把微信浏览器里UA的wifi或4G等网络替换成空,不然切换网络会ID不一样
            return component.value.replace(/\bNetType\/\w+\b/, '')
          }
          return component.value
        })
        // 生成最终id murmur
        const murmur = Fingerprint2.x64hash128(values.join(''), 31)
        const now = new Date(new Date(new Date().getTime()).setFullYear(9998, 0, 0))
        this.$Cookie.set('wiki-bfp', murmur, {
          expires: now,
          path: '/',
          domain: this.$store.state.cookieHost
        })
        this.$store.commit('getbfp', murmur)
      })
    },
    setIsMobile() {
      if (document.documentElement.clientWidth > 799 - this.getScrollbarWidth()) {
        this.$store.commit('setMobile', false)
      } else {
        this.$store.commit('setMobile', true)
      }
    },
    scrollImg() {
      // 图片懒加载滚动事件
      window.addEventListener('scroll', debounce(setImg, 500), {
        passive: true
      })
    },
    getScrollbarWidth() {
      // 计算滚动条宽度
      const scrollDiv = document.createElement('div')
      scrollDiv.style.cssText = 'height: 99px; overflow: scroll; position: absolute; top: -9999px;'
      document.body.appendChild(scrollDiv)
      const scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth
      document.body.removeChild(scrollDiv)
      return scrollbarWidth
    },
    adisShow() {
      // 底部广告显示条件
      const page = ['lang', 'lang-news.html', 'lang-news-id', 'lang-original.html', 'lang-original-id', 'lang-industry.html', 'lang-industry-id', 'lang-brokernews.html', 'lang-brokernews-id', 'lang-wikilist.html', 'lang-wikilist-id', 'lang-wikishow-id', 'lang-newsdetail-id']
      if (page.includes(this.$route.name)) {
        this.$api.ad.bottomad().then((res) => {
          if (!res) return
          this.$set(this.adData, 'jumpLink', res.jumpLink)
          this.$set(this.adData, 'color', res.color)
          this.$set(this.adData, 'jumpType', res.jumpType)
          if (this.getelewidth() == '1') this.$set(this.adData, 'img', res.image1)
          else if (this.getelewidth() == '2') this.$set(this.adData, 'img', res.image2)
          else if (this.getelewidth() == '3') this.$set(this.adData, 'img', res.image3)
          else if (this.getelewidth() == '4') this.$set(this.adData, 'img', res.image4)
          this.$nextTick(() => {
            if (!res.image1) return
            this.$store.commit('setadshow', true)
          })
        })
      }
      if (this.$route.name == 'lang') {
        this.$api.ad.topad().then((res) => {
          if (!res) return
          this.$set(this.topaddata, 'jumpLink', res.jumpLink)
          this.$set(this.topaddata, 'color', res.color)
          this.$set(this.topaddata, 'jumpType', res.jumpType)
          if (this.getelewidth() == '1') this.$set(this.topaddata, 'img', res.image1)
          else if (this.getelewidth() == '2') this.$set(this.topaddata, 'img', res.image2)
          else if (this.getelewidth() == '3') this.$set(this.topaddata, 'img', res.image3)
          else if (this.getelewidth() == '4') this.$set(this.topaddata, 'img', res.image4)
          this.$nextTick(() => {
            if (!res.image1) return
            this.topadshow = true
          })
        })
      }
    },
    getelewidth() {
      const ele = document.documentElement.clientWidth
      if (ele >= 1199 - this.getScrollbarWidth())
        return '1' // >1200
      else if (ele >= 999 - this.getScrollbarWidth() && ele < 1199 - this.getScrollbarWidth())
        return '2' // >999
      else if (ele >= 799 - this.getScrollbarWidth() && ele < 999 - this.getScrollbarWidth())
        return '3' // >799
      else return '4' // m端
    },
    close() {
      // 关闭底部广告
      // this.adshow = false
      this.$store.commit('setadshow', false)
    },
    // Accessed () {
    //   const mttime = dayjs()
    //   const message = `页面访问 ${this.$route.fullPath}`

    //   const CountryCode = this.$store.state.CountryCode
    //   const LanguageCode = this.$store.state.LanguageCode
    //   const CURRIPCOUNTRY = this.$cookies.get('CURRIPCOUNTRY')
    //   const wikibfp = this.$cookies.get('wiki-bfp')
    //   let extentInfo = ''
    //   if (this.$store.state.userIp) {
    //     extentInfo += '"ip":"' + this.$store.state.userIp + '",'
    //   }
    //   if (this.$store.state.user?.userId) {
    //     extentInfo += '"userId":"' + this.$store.state.user.userId + '",'
    //   }
    //   if (CURRIPCOUNTRY == 'cn') {
    //     const province = this.$store.state.curProvince
    //     const city = this.$store.state.curCity
    //     if (province || city) {
    //       extentInfo += '"province":"' + province + '",'
    //       extentInfo += '"city":"' + city + '",'
    //     }
    //   }

    //   const host = this.$store.state?.host
    //   const msg = `${mttime.format('YYYY-MM-DD HH:mm:ss.SSS')} INFO [DATA-API-WEB]:{"Message":"${message}","CountryCode":"${CountryCode}","CURRIPCOUNTRY":"${CURRIPCOUNTRY}","LanguageCode":"${LanguageCode}","host":"${host}","wikibfp":"${wikibfp}","nodeEnv":"${process.env.NODE_ENV}",${extentInfo}"WikiRequestId":"${mttime.format('YYYYMMDDHHmmssSSS')}${(Math.random() * 899999).toString().replace('.', '')}"}`
    // },
    topcountfn() {
      // 顶部统计
      this.adcountfn(this.topaddata.hitsInfo)
    },
    bottomcountfn() {
      this.adcountfn(this.adData.hitsInfo)
    },
    localroutefn() {
      // 存储上一个页面得路由
      const oldroutearr = localStorage.getItem('previousPath') || '[]'
      const oldroute = JSON.parse(oldroutearr)
      const newroute = this.$route.path
      oldroute.unshift(newroute)
      localStorage.setItem('previousPath', JSON.stringify(oldroute.slice(0, 10)))
    },
    toapp() {
      // app路由返回
      // this.sss = document.referrer + '-----' + window.location?.hostname
      // if (document.referrer?.includes(window.location?.hostname)) {
      //   // window.history.back()
      // } else {
      //   // console.log('没有上一个页面')
      //   // try {
      //   //   (window).Communication('backApp')
      //   // } catch (err) {
      //   //   console.log(err, 2222)
      //   // }
      // }
      if (this.$route.name == 'lang-skyline-BrandStory.html') {
        window.Communication('backApp')
      } else if (this.$route.name == 'lang-family-id' || this.$route.name == 'lang-company-id') {
        window.Communication('backApp')
      } else {
        window.Communication('backOuterPage')
        window.history.back()
      }
      console.log(this.$route, 887)
    }
    // adcountfn (hitsType, jumpType = '0', activityType = '1', url = '', tCode = '', iCode = '') { // 广告统计
    //   this.$api.home.invokev3({
    //     tCode, // 文章或交易商或直播房间CODE
    //     iCode, // 文章或交易商或直播房间CODE，用于兼容code
    //     hitsType, // 广告统计类型（不是广告类型），22推流，18轮播，59对联，900顶部广告，901底部广告，902布告栏
    //     jumpType, // 跳转类型，0无跳转，1交易商详情页，2外链接，3新闻文章详情，4实勘，10直播，11直播列表，12模拟交易
    //     url, // 跳转链接，为空时不传
    //     activityType // 广告分类，1广告，2活动，4新闻文章，有值就传，没有就传1
    //   }, {
    //     Routes: 'fxad$hits'
    //   }).then((res) => {
    //     console.log(res, 1111)
    //   }).catch(() => {
    //     console.log('广告统计')
    //   })
    // }
  }
}
